import {
  Modal,
  Button,
  Group,
  Select,
  Radio,
  Flex,
  Box,
  rem,
  Tooltip,
  Text,
} from "@mantine/core";
import trackerIcon from "../../images/tracker-modal-icon.png";
import useStyles from "./style.js";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { DropDownArrowSvg } from "../Svgs/DropDownArrowSvg.jsx";
import {
  calculateDistanceMiles,
  getHighAccuracyLocation,
} from "../../services/UserTracking.js";
function SelectCheckInType({
  opened,
  close,
  open,
  handleModal,
  selectedFacility,
  setSelectedFacility,
  selectedClient,
  setSelectedClient,
  setDisableClockBtn,
  selectedService,
  setSelectedService,
}) {
  const { classes } = useStyles();
  const { profile } = useSelector((state) => state?.profile);
  const { allPatients } = useSelector((state) => state?.patient);
  const [selectedType, setSelectedType] = useState();
  const [facilityValue, setFacilityValue] = useState(null);
  const [warningText, setWarningText] = useState(null);
  // const [origins, setOrigins] = useState(null);
  // const [destinations, setDestinations] = useState(null);
  const [miles, setMiles] = useState(null);
  const [milesError, setMilesError] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const isStaff = profile?.user?.type?.toLowerCase() === "staff";
  const [locationPermission, setLocationPermission] = useState("prompt");
  // const facilities =
  //   profile?.user?.facilityId?.filter(
  //     (_f) =>
  //       (_f?.checkInType === selectedType ||
  //         _f?.checkInType === "no-clockin") &&
  //       _f?.deleted === false
  //   ) || [];

  let facilities = [];

  if (isStaff) {
    facilities =
      profile?.user?.facilityId?.filter(
        (_f) =>
          (_f?.checkInType === selectedType ||
            _f?.checkInType === "no-clockin") &&
          _f?.deleted === false
      ) || [];
  } else {
    facilities = [];
  }

  

  const clockInHandler = () => {
    handleModal("clock in");
  };

  const onChangeFacility = (value) => {
    setSelectedClient(null);
    // set facility value for select component
    setFacilityValue(value);
    const facilities = isStaff ? profile?.user?.facilityId : [];
    let facility_index = facilities?.findIndex((_f) => _f?.id === value);
    // set facility object for payload
    setSelectedFacility(facilities[facility_index]);

    if (!facilities[facility_index]?.checkInType) {
      setWarningText("Ask admin to assign chock in type to the facility");
    } else {
      setWarningText(null);
    }
  };

  // useEffect(() => {
  //   if (selectedType === "client") {
  //     if (selectedClient) {
  //       calculateDistance();
  //     }
  //   } else {
  //     if (selectedFacility) {
  //       calculateDistance();
  //     }
  //   }
  // }, [selectedFacility, selectedClient]);

  const onChangeClient = (value) => {
    setSelectedClient(value);
  };

  const onChangeService = (value) => {
    setSelectedService(value);
  };

  const radioChangeHandler = (value) => {
    setFacilityValue(null);
    setSelectedType(value);
    // setSelectedType({f_type: null, f_id: null});
    // setSelectedType({f_type: value, f_id: null});
  };

  let types = [];
  if (isStaff) {
    types = profile?.user?.facilityId
      ?.filter((f) => f?.deleted === false)
      ?.map((f) => f?.checkInType);
  } else {
    types = [];
  }

  const checkInTypes = new Set(types);

  // const checkInTypes = new Set(
  //   profile?.user?.facilityId
  //   ?.filter((f) => f?.deleted === false)
  //   ?.map((f) => f?.checkInType)
  // );

  const hasFacility = checkInTypes.has("facility");
  const hasClient = checkInTypes.has("client");

  const boxWidth = hasFacility && hasClient ? "48%" : "100%";

  useEffect(() => {
    if (profile?.user?.facilityId) {
      setDisableClockBtn(false);
      for (var a = 0; a < profile?.user?.facilityId?.length; a++) {
        let i = profile?.user?.facilityId[a];
        if (i?.checkInType !== "no-clockin") {
          setDisableClockBtn(false);
        }
      }
    }
  }, []);

  const icon = (
    <DropDownArrowSvg
      color={"#94A3B8"}
      style={{ width: rem(1), height: rem(1) }}
    />
  );

  const handleClose = () => {
    setSelectedFacility(null);
    setSelectedClient(null);
    setSelectedType(null);
    setFacilityValue(null);
    setWarningText(null);
    close();
  };

  useEffect(() => {
    // if (navigator.geolocation) {
    //   navigator.geolocation.getCurrentPosition(
    //     (position) => {
    //       setUserLocation({
    //         lat: position.coords.latitude,
    //         lng: position.coords.longitude,
    //         accuracy: position.coords.accuracy
    //       });
    //       setLocationPermission('granted');
    //     },
    //     (err) => {
    //       setLocationPermission('denied');
    //     }
    //   );
    // } else {
    //   setLocationPermission('denied');
    // }
    accuracyLocation();
  }, []);

  const accuracyLocation = async () => {
    let result = await getHighAccuracyLocation();
    setUserLocation({
      ...result?.locations,
    });
  };

  useEffect(() => {
    if (selectedType) {
      setMiles(null);
      setSelectedAddress(null);
      setSelectedFacility(null);
      setSelectedClient(null);
      setFacilityValue(null);
    }
  }, [selectedType]);

  const calculateDistance = async () => {
    try {
      const origins = `${userLocation.lat},${userLocation.lng}`;

      // const result = await axios.get(
      //   `https://maps.googleapis.com/maps/api/distancematrix/json`,
      //   {
      //     params: {
      //       origins: 'New%20York%20City%2C%20NY',
      //       destinations: 'Washington%2C%20DC',
      //       key: API_KEY,
      //       units: 'imperial' // or 'imperial'
      //     }
      //   }
      // );
      let destination = selectedFacility?.address;
      let clientDetail = null;
      if (selectedType === "client") {
        clientDetail = allPatients?.find((_p) => _p?.id === selectedClient);
        destination = clientDetail?.form1?.previousAddress;
      }
      let payload = {
        origin: origins,
        destination,
        // units: 'imperial' // or 'imperial'
        mode: "WALKING", // or 'imperial'
      };
      let result = await calculateDistanceMiles(payload);
      if (result?.tracking) {
        let legItem = result?.tracking?.legs?.[0];
        let meeterDistance = legItem?.distance?.value;
        let calculatedMiles =
          Math.round((meeterDistance * 0.000621371192 + Number.EPSILON) * 100) /
          100;

        setMiles(calculatedMiles);
        setSelectedAddress(legItem?.end_address);
        if (calculatedMiles > 0.25) {
          setMilesError(true);
        } else {
          setMilesError(false);
        }
      } else {
        if (selectedType === "client") {
          setSelectedAddress(clientDetail?.form1?.previousAddress);
        } else {
          setSelectedAddress(destination);
        }
        setMiles(null);
      }
    } catch (err) {}
  };

  return (
    <>
      <Modal
        opened={opened}
        onClose={handleClose}
        size="lg"
        title="Clock In"
        centered
        radius={16}
        zIndex={1000}
        overlayProps={{
          backgroundOpacity: 0.55,
          blur: 3,
        }}
        className={classes.modal}
      >
        {/* <div className={classes.clockIconParent}>
          <img src={trackerIcon} alt="Tracker Icon" />
        </div>
        <p className={classes.warn}>Select Check In Type</p> */}
        {/* 
        <Select
          className={classes.facilityModal}
          label="Select Facility"
          size="md"
          data={profile?.user?.facilityId?.map((_f) => ({
            label: _f?.name,
            value: _f?.id,
          }))}
          placeholder="Select Facility"
          value={facilityValue}
          onChange={onChangeFacility}
          //disabled={view}
        /> */}

        <Flex align={"center"} justify="center" gap="md">
          <Box
            className={classes.noticeBox}
            style={{
              background: `${milesError ? "#FECDCA" : "#a6f4c580"}`,
              color: `${milesError ? "#B42318" : "#027A48"}`,
            }}
          >
            <Box
              className={classes.notice}
              style={{ color: `${milesError ? "#B42318" : "#027A48"}` }}
            >
              Notice
            </Box>
            {milesError ? (
              <Box className={classes.noticeText}>
                You can’t Clock in until you are within <b>0.25</b> Miles of the
                address
              </Box>
            ) : (
              <Box className={classes.noticeText}>You are set to Clock In</Box>
            )}
          </Box>
        </Flex>
        {checkInTypes.has("facility") || checkInTypes.has("client") ? (
          <Radio.Group
            name="check_in_type"
            label="Clock-in Type"
            required
            value={selectedType}
            onChange={radioChangeHandler}
            mt={10}
          >
            <Group mt="xs" className={classes.radioGroup}>
              {checkInTypes.has("facility") && (
                <Box
                  className={classes.radioBox}
                  style={{
                    cursor: "pointer",
                    border:
                      selectedType === "facility" ? "1px solid #FEB273" : "",
                    backgroundColor:
                      selectedType === "facility" ? "#feb2732b" : "",
                    width: boxWidth,
                  }}
                  onClick={() => setSelectedType("facility")}
                >
                  <Radio
                    value="facility"
                    label="Facility"
                    variant="outline"
                    size="sm"
                    color="orange"
                  />
                </Box>
              )}
              {checkInTypes.has("client") && (
                <Box
                  className={classes.radioBox}
                  style={{
                    cursor: "pointer",
                    border:
                      selectedType === "client" ? "1px solid #FEB273" : "",
                    backgroundColor:
                      selectedType === "client" ? "#feb2732b" : "",
                    width: boxWidth,
                  }}
                  onClick={() => setSelectedType("client")}
                >
                  <Radio
                    value="client"
                    label="Client"
                    variant="outline"
                    size="sm"
                    color="orange"
                  />
                </Box>
              )}
            </Group>
          </Radio.Group>
        ) : (
          <Text ff={"Inter"} fz={14} fw={500} color="red" my={20} ta={"center"}>
            No Facility clock-in type "Facility" or "Client" assigned
          </Text>
        )}

        {/* <Group mt="xs">
            {profile?.user?.facilityId?.find(
              (_f) => _f?.checkInType === "facility"
            ) && <Radio value="facility" label="Facility Type" />}
            {profile?.user?.facilityId?.find(
              (_f) => _f?.checkInType === "client"
            ) && <Radio value="client" label="Client Type" />}
          </Group> */}

        {selectedType === "facility" && (
          <Tooltip
            label={`${
              selectedType === "facility" || selectedType === "no-clockin"
                ? "Facility"
                : "Client"
            } chock-in type is not assigned to facility`}
            position="bottom"
            withArrow
            disabled={facilities?.length > 0}
          >
            <div>
              <Select
                mt={10}
                label="Select Facility"
                size="md"
                data={facilities?.map((_f) => ({
                  label: _f?.name,
                  value: _f?.id,
                  disabled: _f?.checkInType === "no-clockin",
                }))}
                placeholder="Select Facility"
                value={facilityValue}
                rightSectionPointerEvents="none"
                rightSection={icon}
                onChange={onChangeFacility}

                //disabled={view}
              />
            </div>
          </Tooltip>
        )}

        {selectedType === "client" && (
          <Select
            label="Select Client"
            size="md"
            data={allPatients
              ?.filter(
                (_p) => _p?.deleted === false && _p?.active === true
                // _p?.facilityId?.some((_fId) => _fId?.id === facilityValue)
              )
              ?.map((_p) => ({
                label: _p?.name,
                value: _p?.id,
              }))}
            value={selectedClient}
            placeholder="Select Client"
            onChange={onChangeClient}
            rightSectionPointerEvents="none"
            rightSection={icon}
            mt={10}
            //disabled={view}
          />
        )}

        {selectedType === "client" && (
          <Select
            // className={classes.facilityModal}
            label="Select Service"
            size="md"
            data={allPatients
              ?.filter(
                (_p) =>
                  _p?.deleted === false &&
                  _p?.active === true &&
                  _p?.id === selectedClient
              )
              ?.flatMap((_p) => {
                let i = _p?.form1?.services?.map((ser) => ({
                  label: ser?.servicetitle,
                  value: ser?.servicenumber,
                }));
                return i || [];
              })}
            value={selectedService}
            placeholder="Select Service"
            onChange={onChangeService}
            rightSectionPointerEvents="none"
            rightSection={icon}
            mt={10}
            disabled={!selectedClient}
          />
        )}

        <p className={classes.warn}>{warningText}</p>

        {(checkInTypes.has("facility") || checkInTypes.has("client")) && (
          <Box className={classes.distanceSection}>
            <Box
              className={classes.distanceSectionBox}
              style={{ borderBottom: "1px solid #E5E5E5" }}
            >
              <Text fw={700} ff={"Inter"} fz={14}>
                {" "}
                Address
              </Text>
              {selectedAddress && (
                <div style={{ fontWeight: "lighter" }}>{selectedAddress}</div>
              )}
            </Box>
            <Box className={[classes.distanceSectionBox, classes.distance]}>
              <div
                className={classes.iconBox}
                style={{ background: milesError ? "#FEF3F2" : "#D9F2EF" }}
              >
                <img
                  src={`/assets/images/${
                    milesError ? "distance.png" : "distance_green.png"
                  }`}
                  alt="logo"
                  style={{ width: "30px", height: "30px", objectFit: "cover" }}
                />
              </div>
              {miles && <div>{miles} Miles away</div>}
            </Box>
          </Box>
        )}

        <Flex justify="flex-end">
          <Group mt="xl">
            <Button onClick={handleClose} className={classes.cancelBtn}>
              Cancel
            </Button>
            <Button
              className={classes.action}
              onClick={clockInHandler}
              disabled={
                selectedType !== "client" && !selectedFacility
                  ? true
                  : selectedFacility && warningText
                  ? true
                  : milesError
                  ? true
                  : false
              }
            >
              Clock-in
            </Button>
          </Group>
        </Flex>
      </Modal>
    </>
  );
}

export default SelectCheckInType;
